module.exports = __webpack_public_path__ + "static/media/game-of-life.d864441a.mp4";